import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { DateTime } from 'luxon';
import { Box, Button, DialogActions, DialogContent, Grid, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { ModalActionProps } from 'models/AutoModals';
import carListFamily from 'recoil/atoms/carListFamily';


type YardInDialogProps = {
    id: number,
} & ModalActionProps<{[k: number]: string}>

const YardInDialog = ({ id, onFinish }: YardInDialogProps) => {
    const {t} = useTranslation('cars');
    const cars = useRecoilValue(carListFamily('pending'));
    const [dates, setDates] = useState<{[k: number]: DateTime}>({});
    const [filter, setFilter] = useState('');

    let filtered = cars.filter(c =>
        (!c.yard || (c.yard.id === id && !c.yard.dateIn)) &&
        (!filter || c.chassisNumber.includes(filter))
    )
        .slice(0, 10);

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!Object.keys(dates).length)
            return;

        onFinish(Object.fromEntries(
            Object.entries(dates).map(([key, value]) => [key, value.toISODate()!])
        ));
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <TextField
                    label={t('chassis_filter')}
                    fullWidth
                    value={filter}
                    onChange={e => setFilter(e.target.value.toLowerCase())}
                />
                <Grid container columnSpacing={2}>
                    {filtered.map(c => (
                        <Fragment key={c.id}>
                            <Grid item xs={4}>
                                {c.make} {c.model}
                            </Grid>
                            <Grid item xs={4}>
                                {c.chassisNumber}
                            </Grid>
                            <Grid item xs={4}>
                                <DatePicker
                                    format="yyyy-MM-dd"
                                    slotProps={{ textField: { fullWidth: true } }}
                                    onChange={d => setDates(old => ({...old, [c.id]: d!}))}
                                    value={dates[c.id] || null}
                                />
                            </Grid>
                        </Fragment>
                    ))}
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button type="submit">Update {Object.keys(dates).length} cars</Button>
            </DialogActions>
        </Box>
    );
};

export default YardInDialog;
